module.exports = __webpack_public_path__ + "media/images/android-chrome-512x512-4c12f5502e2d8b611f0328bc86fadfc9.png";